import React, { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { submitOrder } from "../lib/api";

const ContactForm = ({ variant = "dark" }) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [agree, setAgree] = useState(true);
  const [loading, setLoading] = useState(false);

  const isDark = variant === "dark";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !phone) {
      toast.error("Please fill in all required fields");
      return;
    }
    if (!agree) {
      toast.error("Please agree to data processing");
      return;
    }
    try {
      setLoading(true);
      await submitOrder({ name, phone, message });
      toast.success("Your request has been sent. We'll get back to you shortly.");
      setName("");
      setPhone("");
      setMessage("");
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong. Please try again or call us directly.");
    } finally {
      setLoading(false);
    }
  };

  const inputClass = isDark ? "pt-input" : "pt-input-light";
  const labelClass = isDark
    ? "text-xs uppercase tracking-[0.06em] text-white/60 font-medium"
    : "text-xs uppercase tracking-[0.06em] text-[#7a7a7a] font-medium";

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <label className={labelClass}>Your name *</label>
        <input className={inputClass} value={name} onChange={(e) => setName(e.target.value)} placeholder="Full name" />
      </div>
      <div>
        <label className={labelClass}>Phone *</label>
        <input className={inputClass} value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+971 ..." />
      </div>
      <div>
        <label className={labelClass}>Message</label>
        <textarea rows={3} className={inputClass} value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Tell us about your enquiry" />
      </div>
      <label className={`flex items-start gap-2 text-xs ${isDark ? "text-white/60" : "text-[#7a7a7a]"}`}>
        <input type="checkbox" className="mt-0.5" checked={agree} onChange={(e) => setAgree(e.target.checked)} />
        <span>I agree to processing of personal data</span>
      </label>
      <button type="submit" disabled={loading} className="btn-red disabled:opacity-60">
        {loading ? "Sending..." : "Send"} <ArrowRight size={14} />
      </button>
    </form>
  );
};

export default ContactForm;
